$(document).ready(function () {  

  // dep1 hover 
  $(".menu-list > li").hover(function($e){
    var _hoverIndex =  $(this).index();    
    $(".multi_coll > .colitem").removeClass("dep1_hover");
		$(".multi_coll > .colitem").eq(_hoverIndex).addClass("dep1_hover");
		subHeight();
  }, function(){    
    //$(".multi_coll > .colitem").delay(10).removeClass("dep1_hover");
  })
  
    // dep2 hover
  $(".menu_dep1 .multi_coll > .colitem").hover(function($e){
    var _hoverIndex =  $(this).index();
    $(".menu_dep1  .menu-list > li").eq(_hoverIndex).addClass("hover");

    $(".multi_coll > .colitem").removeClass("dep1_hover");
    $(this).addClass("hover");
  }, function(){
    $(".menu_dep1  .menu-list > li").removeClass("hover");
    $(this).removeClass("hover");
  });

  // dep3 hover
  $(".menu_dep1 .menu_dep3").hover( function(){
    $(this).closest("li").addClass("on");
  }, function(){
    $(this).closest("li").removeClass("on");
  });

  // dep3 item hover
  $(".menu_dep3.dep3_bg .sub-list > li").hover( function(){
    var _dep3_id = $(this).attr("data-index");	
    $(".menu_dep2 > .sub-list > li[data-index="+_dep3_id+"]").addClass("on");
    subHeight();
  },function(){
    $(".menu_dep2 > .sub-list > li").removeClass("on");
  });

  function subHeight(){
		$(".LN000019 .multi_coll > .colitem > .sub-list").each(function(){
			var _h =  $(".gnb_col3 .multi_coll").height();
			$(this).css({ "min-height" : "auto" });
			$(this).css({ "min-height" : _h });
		}); 
	
    if($(".multi_coll").innerHeight() < $(".menu_dep3.dep3_bg > .sub-list").innerHeight()){
      $(".multi_coll").height( $(".menu_dep3.dep3_bg > .sub-list").innerHeight() );
    }
    console.log( $(".multi_coll").height(),  $(".menu_dep3.dep3_bg > .sub-list").innerHeight());
  }
  subHeight();


  
  /* ========== sticky ============ 라벨 */
  // sticky 
  if( $(".sticky-wrap .labelscroll-area").length ){
    $('.labelscroll-area .mCustomScrollbar_x').mCustomScrollbar({autoHideScrollbar: true, axis:'x',advanced:{autoExpandHorizontalScroll:true}});
  }


})//ready



